import { SelectableOption } from "@zfp-akademie-a-s/zfp-design";
import { Spacing } from "Infrastructure/Themes/Themes";
import type { ReactElement, ReactNode } from "react";
import { useIsPrintMode } from "./QuestionnaireContext";

export const printAnswerPaddingSx = { px: Spacing.M, py: Spacing.S };

// The MUI default for an unchecked control is text.secondary, which is too light against white. The checked
// and disabled colours stay MUI's, their selectors outrank this one.
export const optionControlSx = {
  p: 0,
  color: "text.secondary",
  "&:hover": { bgcolor: "transparent" },
  "& .MuiSvgIcon-root": { fontSize: 18 },
};

type Props = {
  control: ReactElement;
  label: ReactNode;
  value?: string;
  disabled?: boolean;
};

// An answer row: the package's SelectableOption, which reads the chosen state from its control.
export const QuestionOption = ({ control, label, value, disabled }: Props) => {
  const isPrint = useIsPrintMode();

  return (
    <SelectableOption
      value={value}
      control={control}
      label={label}
      disabled={disabled}
      // Answers in regular weight under the medium question; the package's rule still sets the chosen one in medium.
      // The touch target means nothing on paper and would only stretch the PDF.
      sx={{
        breakInside: "avoid",
        py: Spacing.S,
        "& .MuiFormControlLabel-label": { fontWeight: 400 },
        ...(isPrint && { minHeight: 0, ...printAnswerPaddingSx }),
      }}
    />
  );
};
